import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const upsertMeta = (attrName, attrVal, content) => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attrName}="${attrVal}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attrName, attrVal);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const upsertAlternate = (hreflang, href) => {
  let el = document.head.querySelector(`link[rel="alternate"][hreflang="${hreflang}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "alternate");
    el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const clamp = (text, max = 160) => {
  if (!text) return "";
  const t = String(text).replace(/\s+/g, " ").trim();
  return t.length > max ? `${t.slice(0, max - 1).trimEnd()}…` : t;
};

// Updates document title, description, OG/Twitter tags and canonical per route.
// Pass `noindex` on 404/empty pages so Google removes them from the index.
export const Seo = ({ title, description, noindex = false }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (title) document.title = title;
    const desc = clamp(description);
    upsertMeta("name", "description", desc);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", window.location.origin + pathname);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", desc);
    // Robots directive — either force noindex or explicitly allow indexing.
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    // Canonical = current locale URL (query stripped)
    upsertCanonical(window.location.origin + pathname);
    // Per-locale hreflang alternates (distinct URLs per language)
    const parts = pathname.split("/");
    const rest = ["en", "fr", "tr"].includes(parts[1]) ? "/" + parts.slice(2).join("/") : pathname;
    const clean = rest === "/" ? "" : rest.replace(/\/$/, "");
    const o = window.location.origin;
    upsertAlternate("en", `${o}/en${clean}`);
    upsertAlternate("fr", `${o}/fr${clean}`);
    upsertAlternate("tr", `${o}/tr${clean}`);
    upsertAlternate("x-default", `${o}/en${clean}`);
  }, [title, description, pathname, noindex]);
  return null;
};

export default Seo;
